import { render, staticRenderFns } from "./BaseContentBlock.vue?vue&type=template&id=2d73ac5e&"
import script from "./BaseContentBlock.vue?vue&type=script&lang=js&"
export * from "./BaseContentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports